
export default () => ({});
